<div class="info-header">
  <div class="container-fluid lh-container-fluid d-block d-md-none">
    <div class="flex">
      <h1 class="heading-5">{{ 'SHOP_MANAGER_DASHBOARD' | translate }}</h1>
    </div>
  </div>
</div>

<div class="container-fluid lh-container-fluid">
  <div class="row">
    <div class="col-12" [hidden]="isLoading">
      <div *ngIf="showAddStorageLocationAlert" class="alert alert-warning">
        {{ 'ADD_FIRST_STORAGE_LOCATION_FOR_EXTRA_REVENUE' | translate }}
        <div class="mt-2 text-end">
          <button id="reviewAndAcceptTermsOfService" class="btn btn-warning" (click)="manageShopsComponent.addShop()">
            {{ 'ADD_STORAGE_LOCATION' | translate }}
          </button>
        </div>
      </div>

      <!-- Verify business alert -->
      <div *ngIf="showVerifyBusinessAlert" class="alert alert-warning">
        <strong>{{ 'IMPORTANT_COLON' | translate | uppercase }}</strong>
        {{ 'ADDITIONAL_BUSINESS_INFO_REQUIRED' | translate }}
        <div class="mt-2 text-end">
          <button
            id="verifyBusiness"
            class="btn btn-warning"
            (click)="managePayoutMethodsComponent.managePayoutProviderAccount()"
          >
            {{ 'VERIFY_YOUR_BUSINESS' | translate }}
          </button>
        </div>
      </div>

      <!-- Terms of Service alert -->
      <div *ngIf="showTosAlert" class="alert alert-warning">
        <strong>{{ 'IMPORTANT_COLON' | translate | uppercase }}</strong>
        {{ 'TOS_ACCEPTANCE_PART_1' | translate }}
        <a class="href" [href]="tosLink" target="_blank">{{ 'TOS_ACCEPTANCE_PART_2' | translate }}</a>
        <div class="mt-2 text-end">
          <!-- <button id="reviewAndAcceptTermsOfService" class="btn btn-warning" routerLink="/terms-of-service"> -->
          <button id="reviewAndAcceptTermsOfService" class="btn btn-warning" (click)="startTosAcceptance()">
            {{ 'ACCEPT' | translate }}
          </button>
        </div>
      </div>

      <div *ngIf="showPayoutMethodAlert" class="alert alert-warning">
        <strong>{{ 'IMPORTANT_COLON' | translate | uppercase }}</strong>
        {{ 'PAYOUT_METHOD_NEEDED_FOR_TRANSFER_OF_EARNINGS' | translate }}
        <div class="mt-2 text-end">
          <button
            id="addPayoutMethod"
            class="btn btn-warning"
            (click)="managePayoutMethodsComponent.addPayoutProviderAccount()"
          >
            {{ 'ADD_PAYOUT_METHOD' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="col-12" *ngIf="showActivityStats && isShopOwner">
      <div class="stats-container mt-4">
        <h3 class="heading">{{ 'YOUR_ACTIVITY' | translate }}</h3>
        <hr />

        <div class="header">
          <div class="fl-1">
            <div class="period">{{ startDate | date }} – {{ endDate | date }}</div>
          </div>
          <div class="dropdown" dropdown *ngIf="statsPeriod">
            <!-- Stats period dropdown toggle button -->
            <button
              id="statsPeriodDropdown"
              class="btn btn-md btn-link stats-period-selector"
              [disabled]="isLoading"
              type="button"
              dropdownToggle
            >
              <span class="bi bi-caret-down-fill"></span> {{ statsPeriod | translate }}
            </button>
            <!-- Stats period dropdown list -->
            <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu role="menu" aria-labelledby="share-actions">
              <li *ngFor="let option of reportingPeriodOptions">
                <a class="href" (click)="statsPeriod = option">{{ option | translate }}</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="text-center mt-4" *ngIf="!displayedStats && (isLoading || isLoadingStats)">
          <lh-shared-ui-spinner [visible]="true"></lh-shared-ui-spinner>
        </div>

        <div class="text-center" *ngIf="!isLoading && !isLoadingStats && !activityStatsValid">
          <div class="alert alert-info medium">
            {{ 'NO_DATA_AVAILABLE_CHECK_AGAIN_LATER' | translate }}
          </div>
        </div>

        <div class="row stats-values" *ngIf="activityStatsValid">
          <div class="col-12 stat" [class.updating]="isLoadingStats" *ngIf="isLineChartEnabled && !isReplacingStats">
            <lh-line-chart [currency]="displayedStats.currency"></lh-line-chart>
          </div>

          <div class="col-6 col-sm-3 stat" [class.updating]="isLoadingStats" *ngIf="!isReplacingStats">
            <lh-number-card
              [label]="('REVENUE' | translate) + '*'"
              [value]="displayedStats.totalRevenue"
              [currency]="displayedStats.currency"
            ></lh-number-card>
          </div>

          <div class="col-6 col-sm-3 stat" [class.updating]="isLoadingStats" *ngIf="!isReplacingStats">
            <lh-number-card
              [label]="'TIPS' | translate"
              [value]="displayedStats.totalTips"
              [currency]="displayedStats.currency"
            ></lh-number-card>
          </div>

          <div
            class="col-6 col-sm-3 stat"
            [class.d-none]="isLineChartEnabled"
            [class.d-sm-block]="isLineChartEnabled"
            [class.updating]="isLoadingStats"
            *ngIf="!isReplacingStats && !isShowingExtendedStats"
          >
            <lh-number-card
              [label]="'CUSTOMERS' | translate"
              [value]="displayedStats.totalPaidBookings"
            ></lh-number-card>
          </div>

          <div
            class="col-6 col-sm-3 stat"
            [class.d-none]="isLineChartEnabled"
            [class.d-sm-block]="isLineChartEnabled"
            [class.updating]="isLoadingStats"
            *ngIf="!isReplacingStats && !isShowingExtendedStats"
          >
            <lh-number-card
              [label]="'PER_CUSTOMER' | translate"
              [value]="displayedStats.averageValuePerBooking"
              [currency]="displayedStats.currency"
              [decimalCount]="2"
              (click)="onAverageValueClick()"
            ></lh-number-card>
          </div>

          <div
            class="col-6 col-sm-3 stat"
            [class.d-none]="isLineChartEnabled"
            [class.d-sm-block]="isLineChartEnabled"
            [class.updating]="isLoadingStats"
            *ngIf="!isReplacingStats && isShowingExtendedStats"
          >
            <lh-number-card [label]="'BAGS' | translate" [value]="displayedStats.totalBagsStored"></lh-number-card>
          </div>

          <div
            class="col-6 col-sm-3 stat"
            [class.d-none]="isLineChartEnabled"
            [class.d-sm-block]="isLineChartEnabled"
            [class.updating]="isLoadingStats"
            *ngIf="!isReplacingStats && isShowingExtendedStats"
          >
            <lh-number-card
              [label]="'PER_BAG' | translate | uppercaseFirstLetter"
              [value]="displayedStats.averageValuePerBag"
              [currency]="displayedStats.currency"
              [decimalCount]="2"
              (click)="onAverageValueClick()"
            ></lh-number-card>
          </div>

          <div class="col-12" *ngIf="!isReplacingStats">
            <div class="stats-disclaimer">* {{ 'REVENUE_EXCLUDING_TIPS' | translate }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="control-panels">
      <div class="row">
        <div class="col-12 mt-4" *ngIf="showActivityStats && isShopOwner">
          <h3 class="heading">{{ 'MANAGE_YOUR_BUSINESS' | translate }}</h3>
          <hr />
        </div>

        <!--Account completeness-->
        <div class="col-12 col-sm-6" *ngIf="showAccountCompleteness && isShopOwner">
          <h6>{{ 'PROFILE_COMPLETENESS' | translate }}</h6>

          <div class="control-panel">
            <div class="text-center mt-4" *ngIf="isLoading">
              <lh-shared-ui-spinner [visible]="true"></lh-shared-ui-spinner>
            </div>

            <div [hidden]="isLoading">
              <div>
                <div class="task-label" *ngIf="nextIncompleteTask">
                  <strong>{{ 'NEXT' | translate }}:</strong> {{ nextIncompleteTask.description }}
                </div>
                <lh-progress-bar [currentValue]="completedTaskCount" [maxValue]="profileTaskCount"></lh-progress-bar>
              </div>

              <p>{{ 'KEEPING_PROFILE_COMPLETE' | translate }}</p>

              <table class="table mt-3">
                <tr *ngFor="let task of visibleProfileTasks" [class.complete]="task.completed">
                  <td class="checkmark">✔</td>
                  <td>{{ task.description }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div class="col-12 d-block d-sm-none">
          <hr />
        </div>

        <!--Payout methods-->
        <div class="col-12 col-sm-6" *ngIf="isShopOwner">
          <h6>{{ 'YOUR_PAYOUT_METHODS' | translate }}</h6>

          <div class="control-panel" *ngIf="profileTasksReady | async">
            <lh-manage-payout-methods
              #managePayoutMethodsComponent
              (payoutMethodsChange)="onPayoutMethodsChange($event)"
              (payoutVerificationStatusChange)="onPayoutVerificationStatusChange($event)"
              [payoutCurrency]="payoutCurrency"
              [selectedCountry]="operatingCountry"
              [storageLocationId]="firstStorageLocationId"
            ></lh-manage-payout-methods>
          </div>
        </div>

        <div class="col-12" *ngIf="isShopOwner">
          <hr />
        </div>

        <!-- Shops you manage -->
        <div class="col-12">
          <h6 *ngIf="isImpersonationMode || (isShopOwner && (profileTasksReady | async))">
            {{ 'YOUR_STORAGE_LOCATIONS' | translate }}
          </h6>

          <div class="control-panel" *ngIf="isImpersonationMode || (isShopOwner && (profileTasksReady | async))">
            <lh-manage-shops #manageShopsComponent (shopsChange)="onShopsChange($event)"></lh-manage-shops>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="app-info" *ngIf="appVersion">
    <div class="app-name">LuggageHero Storage Manager</div>
    <div class="app-version">v{{ appVersion }}</div>
  </div>
</div>

<!-- Terms of Service acceptance modal -->
<div
  class="modal fade"
  bsModal
  #tosAcceptanceModal="bs-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-fullscreen-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{ 'CONFIRM_ACCEPTANCE' | translate }}</h4>
        <button
          id="closeReviewsModal"
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="tosAcceptanceModal.hide()"
        >
          <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <div *ngIf="!storageManagerPhoneNumber">
          <p>
            {{ 'WILL_SEND_OTP_USE_TO_ACCEPT_TOS' | translate }}
            <a class="href" [href]="tosLink" target="_blank">{{ 'TOS_ACCEPTANCE_PART_2' | translate }}</a>
          </p>
          <p>{{ 'PROVIDE_MOBILE_PHONE_NO_TO_CONTINUE' | translate }}.</p>
          <form [formGroup]="phoneNumberForm">
            <div class="form-group">
              <lh-phone-input
                id="phone"
                formControlName="phone"
                [advancedMode]="true"
                [(ngModel)]="phoneNumber"
                [placeholder]="'PHONE_NUMBER' | translate"
                [(selectedCountry)]="phoneCountry"
                [requestFocus]="false"
              >
              </lh-phone-input>
              <div *ngIf="isPhoneNumberFormSubmitted && phoneInputError" class="alert alert-danger">
                {{ phoneInputError | translate }}
              </div>
            </div>
          </form>

          <div class="form-group text-end">
            <button
              class="btn btn-block btn-primary mt-2"
              (click)="savePhoneNumber()"
              [disabled]="isLoading || (phoneInputError && isPhoneNumberFormSubmitted)"
            >
              <span *ngIf="!isLoading">{{ 'SEND_CODE' | translate }}</span>
              <span *ngIf="isLoading">{{ 'PLEASE_WAIT' | translate }}</span>
            </button>
          </div>
        </div>
        <div *ngIf="storageManagerPhoneNumber">
          <p>{{ 'OTP_SENT_TO_PHONE_NO_ENDING_IN' | translate }} {{ storageManagerPhoneNumberLast4 }}</p>
          <p>{{ 'ENTER_CODE_TO_CONFIRM_ACCEPTANCE' | translate }}</p>
          <p>
            <code-input
              [isCodeHidden]="false"
              [isNonDigitsCode]="false"
              [codeLength]="5"
              (codeCompleted)="onCodeCompleted($event)"
            >
            </code-input>
          </p>
          <p class="text-center">
            Didn't receive the code? <a class="href" (click)="resendConfirmationCode()">Resend</a>
          </p>

          <div class="validation-spinner">
            <lh-shared-ui-spinner [visible]="isLoading"></lh-shared-ui-spinner>
            <!-- TODO: Make this a dynamic status message that supports both error and success -->
            <div *ngIf="!isLoading && isConfirmationCodeSent" class="text-success">New code sent!</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
